<script setup>
  import {onMounted, ref, watch} from "vue";
  import Multiselect from "vue-multiselect";

  const props = defineProps({
    sorts: {
      type: [],
      default: () => [],
      required: true,
    }
  });

  const emit = defineEmits(["update:sortOrder"]);

  const trans = (key) => {
    return _.get(window.translations, key, key);
  };

  const sortValue = ref(props.sorts.filter(sort => sort.selected )[0] || null);

  const sortOptions = ref(props.sorts);


  watch(sortValue, (newVal) => {
    if (newVal != null) {
      sortOptions.value.forEach(sort => {
        if (sort.value === newVal.value) {
          sort.selected = true;
        } else {
          sort.selected = false;
        }
      });
    }
    emit("update:sortOrder", newVal);
  });

  onMounted(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.has('order[number]')) {
      sortOptions.value.forEach(sort => {
        if (sort.value === url.searchParams.get('order[number]')) {
          sort.selected = true;
        } else {
          sort.selected = false;
        }
      });

      sortValue.value = sortOptions.value.filter(sort => sort.selected)[0];
    }

  });
</script>

<template>
  <div class="order-by-asc-container">
    <multiselect
      v-model="sortValue"
      :options="sortOptions"
      :searchable="false"
      :allow-empty="true"
      label="name"
      track-by="value"
      placeholder="Order by..."
    >
      <template v-slot:singleLabel="{ option }">
        <span class="multiselect-label"><strong>{{ option.name }}</strong></span>
      </template>
      <template v-slot:placeholder>
        <span class="multiselect-label">{{ trans('Order by...') }}</span>
      </template>
    </multiselect>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

</style>



